import _objectSpread from "/mnt/e/www/joinengineconvas/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import { dsnToString, createEnvelope } from '@sentry/utils';
/**
 * Creates an envelope from a user feedback.
 */

function createUserFeedbackEnvelope(feedback, _ref) {
  var metadata = _ref.metadata,
      tunnel = _ref.tunnel,
      dsn = _ref.dsn;

  var headers = _objectSpread({
    event_id: feedback.event_id,
    sent_at: new Date().toISOString()
  }, metadata && metadata.sdk && {
    sdk: {
      name: metadata.sdk.name,
      version: metadata.sdk.version
    }
  }, !!tunnel && !!dsn && {
    dsn: dsnToString(dsn)
  });

  var item = createUserFeedbackEnvelopeItem(feedback);
  return createEnvelope(headers, [item]);
}

function createUserFeedbackEnvelopeItem(feedback) {
  var feedbackHeaders = {
    type: 'user_report'
  };
  return [feedbackHeaders, feedback];
}

export { createUserFeedbackEnvelope };